export enum ReportClaimStatus {
    PENDING = 'PENDING', // No case id
    APPROVED = 'APPROVED', // Case ID
    BOOKED = 'BOOKED', // Service & Contractor & Slot/Visit data is known
    SERVICE_DELIVERED = 'SERVICE_DELIVERED', // After visit date / invoice / medical documentation
    CLOSED = 'CLOSED', // Claim fully finished
    REJECTED = 'REJECTED',
    CANCELED_BY_CUSTOMER = 'CANCELED_BY_CUSTOMER',
    ERROR = 'ERROR',
    REFUND_APPROVED = 'REFUND_APPROVED',
}
